import { EditableList } from '../../../../compnents/list/EditableList'
import React, { ReactElement, useEffect, useState } from 'react'
import { notification } from 'antd'
import { NurseQuerys } from '../../formula/noformula/Query'
import { useDispatch, useSelector } from 'react-redux'
import { doctorcolumn } from '../noformula/columns'
import {
  selectNoformulaData,
  getNoformulaList,
  getNoformula,
  selectCurrent,
  selectTotal,
  setCurrent,
  getExecuteState,
  selectPageLoading,
  setPageLoading,
} from './noformulaSlice'
import { NoFormulaParmas } from '../../../../services/formula'
import { ModelList } from './Modallist'
import styles from '../formulas/formula.module.css'
import { recipeColumns } from './column'
import { RootDispatch } from '../../../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { PrintTemplateModal } from '../../../print/PrintTemplateModal'
import { PrintTemplateCategory } from '../../../../models/print'
import { setTreatmentId } from '../../../PharmacyRetail/PharmacyRetailSlice'
import { getPrintZXDData } from '../../../treatment/editor/recipeEditorSlice'

export const NoFormula = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const CREDENTIAL_KEY = 'states'

  const [queries, setQueries] = useState<NoFormulaParmas>({})

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [isTreatmentId, setIsTreatmentId] = useState('')

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [SelectId, setSelectId] = useState(0)

  const [recipeId, setRecipeId] = useState<any>()

  const [treatmentId, setTreatmentId] = useState<any>()

  const Current = useSelector(selectCurrent)

  const total = useSelector(selectTotal)

  const data = useSelector(selectNoformulaData)

  const [size, setSize] = useState(10)

  const pageLoadingRX = useSelector(selectPageLoading)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const getReciptPrintList = (recipeId?: any) => {
    dispatch(getPrintZXDData(recipeId))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  useEffect(() => {
    if (queries?.timeHead) {
      dispatch(setPageLoading(true))
      dispatch(
        getNoformulaList({
          ...queries,
          current: Current,
          size,
          state: 0,
        })
      )
      setTimeout(() => {
        dispatch(setPageLoading(false))
      }, 3000)
    }
  }, [queries, size, Current])

  useEffect(() => {
    if (queries?.param?.length == 9 && Number(data.length) == 1) {
      dispatch(
        getNoformula({
          registrationId: data[0]?.registrationId,
          state: 0,
          normalUsemethod: data[0]?.normalUsemethod,
        })
      )
      setIsModalVisible(true)
      setIsTreatmentId(data[0]?.treatmentId)
      //  setPaymentId(data[0]?.paymentId)
    }
  }, [data])

  const range: any = sessionStorage.getItem(CREDENTIAL_KEY)
  return (
    <>
      <div className={styles.contenter}>
        <NurseQuerys
          loading={pageLoadingRX}
          isModalVisible={isModalVisible}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v })
            dispatch(setCurrent(1))
            const state: any = v.range
            sessionStorage.setItem(CREDENTIAL_KEY, state)
          }}
        />
        <EditableList
          rowKey={(_, i) =>
            queries
              ? (queries.size || 0) * (queries.current || 0) + (i || 0)
              : 0
          }
          loading={pageLoadingRX}
          className={styles.noformula}
          page={{
            items: data,
            current: Current,
            size: size,
            total: total,
          }}
          onChangePage={(current, pageSize) => {
            setSize(pageSize as number)
            dispatch(setCurrent(current))
          }}
          columns={
            range === '1'
              ? doctorcolumn((t, v) => {
                  if (t == '执行') {
                    dispatch(
                      getExecuteState({
                        useMethod: v?.normalUsemethod,
                        treatmentId: v?.treatmentId,
                        range,
                      })
                    )
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '执行成功',
                          duration: 3,
                        })
                        dispatch(
                          getNoformulaList({
                            ...queries,
                            current: Current,
                            size,
                            state: 0,
                          })
                        )
                      })
                  } else if (t == '打印') {
                    setTreatmentId(v?.treatmentId)
                    setIsPrintModalVisible(true)
                  } else {
                    return
                  }
                }, size * (Current - 1))
              : recipeColumns((t, v) => {
                  if (t == '执行') {
                    dispatch(
                      getExecuteState({
                        useMethod: v?.normalUsemethod,
                        recipeId: v?.recipeId,
                        range,
                      })
                    )
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '执行成功',
                          duration: 3,
                        })
                        dispatch(
                          getNoformulaList({
                            ...queries,
                            current: Current,
                            size,
                            state: 0,
                            range: range,
                          })
                        )
                      })
                  } else if (t == '打印') {
                    setRecipeId(v?.recipeId)
                    if (v.recipeId) {
                      getReciptPrintList(v.recipeId)
                    }
                    setIsPrintModalVisible(true)
                  } else {
                    return
                  }
                }, size * (Current - 1))
          }
          onRow={(d: any) => ({
            onDoubleClick: () => {
              dispatch(
                getNoformula({
                  registrationId: d.registrationId,
                  state: 0,
                  normalUsemethod: d.normalUsemethod,
                })
              )
              setIsModalVisible(true)
              setIsTreatmentId(d.treatmentId)
            },
          })}
        />
        <ModelList
          visible={isModalVisible}
          treatmentId={isTreatmentId}
          onOk={() => {
            setIsModalVisible(false)
            dispatch(
              getNoformulaList({
                ...queries,
                current: Current,
                size,
                state: 0,
                range: range,
              })
            )

            setSelectId(0)
          }}
          onCancel={() => {
            setIsModalVisible(false)
            dispatch(
              getNoformulaList({
                ...queries,
                current: Current,
                size,
                state: 0,
                range: range,
              })
            )
            setSelectId(0)
          }}
        />
        <PrintTemplateModal
          recipeId={recipeId}
          printZXDData={printZXDData}
          pagePrintFlag={'zxdPrint'}
          templateCategory={PrintTemplateCategory.CFDY}
          visible={isPrintModalVisible}
          treatmentId={treatmentId}
          onCancel={() => setIsPrintModalVisible(false)}
        />
      </div>
    </>
  )
}
